<template>
  <div>

    <!--    签离成功失败弹框-->
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onNotifyDialogClose"></my-notify-dialog>

    <el-dialog :visible.sync="selectVisitorDialogVisible" title="选择访客信息" width="90%" center>
      <div class="dialog-container">
        <el-table :data="searchVisitorList" height="500">
          <el-table-column prop="name" label="访客姓名"></el-table-column>
          <el-table-column prop="ic" label="身份证号"></el-table-column>
          <el-table-column prop="tel" label="手机号"></el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-button @click="doOnGetVisitor(scope.row)" type="success">
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-container class="common-page-box">
      <el-header class="header-box">
        <div class="empty"></div>
        <div class="title">{{ title }}</div>
        <BackIcon></BackIcon>
      </el-header>
      <el-main v-if="step === 0" class="main-content" style="margin-bottom: 15px">
        <div class="main-half main-left">
          <template v-if="!showApplyList">
            <div>
              <div class="search-box">
                <el-button style="width: 600px;font-size: 35px" @click="onEnsureClick" type="primary">开始身份证签离
                </el-button>
              </div>
              <div class="agreement-box">
                <div v-if="agreement.valid ">
                  <el-checkbox size="mini" v-model="haveRead">请阅读并同意《{{ agreementTitle }}》</el-checkbox>
                </div>
              </div>
            </div>
          </template>
          <el-table v-else :data="applyList" border style="width: 90%;">
            <el-table-column prop="myVisitorName" label="访客"></el-table-column>
            <el-table-column prop="myEmployeeName" label="受访者"></el-table-column>
            <el-table-column prop="myBeginTime" label="开始时间"></el-table-column>
            <el-table-column prop="myEndTime" label="结束时间"></el-table-column>
            <el-table-column prop="myStatus" label="状态">
              <template v-slot="scope">
                <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doSignLeave(scope.row.data)"
                           type="success">
                  签离
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="main-half" v-if="agreement.valid">
          <div class="agreement-title">{{ agreementTitle }}</div>
          <div class="agreement-text" v-html="agreement.content"></div>
        </div>

      </el-main>
      <el-main v-else class="show-qr-notify" style="margin-bottom: 15px">

        <el-image :src="require('@/assets/icon_ic_card.png')"></el-image>
        <div class="notify-big">请将身份证放在读卡区</div>

      </el-main>

    </el-container>

  </div>
</template>

<script>


import BackIcon from "@/components/BackIcon";

import {getApplyListByVisitCode, signLeave, visitorSearchByIdCardNo} from "@/api/visit-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {areaCheckMixin} from "@/utils/myMixins";
import {usual_visitor_sign_mixin} from "@/helper/usual_visitor_mixin";

export default {
  name: "IdCardLeave",
  components: {MyNotifyDialog, BackIcon},
  mixins: [areaCheckMixin, usual_visitor_sign_mixin],

  mounted() {
    this.setupAreaInfo()
    // window.addEventListener('idCardCheckEvent', this.handleInputFromJava)

    this.startTimer()
  },
  destroyed() {
    this.stopTimer()
    // window.removeEventListener('idCardCheckEvent', this.handleInputFromJava)
  },
  computed: {
    agreement() {
      return this.$store.state.signLeaveAgreement
    },

  },
  data() {
    return {
      title: "身份证签离",

      inputCode: "",
      haveRead: false,


      applyList: [],
      showApplyList: false,
      agreementDialogVisible: false,

      notify: {
        title: "签到结果",
        show: false,
        success: true,
        msg: "签到成功",
      },

      step: 0,

      visitor: null, // 人证核验成功后的访客信息

      searchVisitorList: [], // 身份证号查询到的访客列表
      selectVisitorDialogVisible: false,
      selectVisitor: null, // 最终选择的访客信息
      agreementTitle: "签离须知",

      timer: null,

    }
  }, // end data

  methods: {


    startTimer() {
      this.timer = setInterval(() => {
        this.checkIdCard()
      }, 1000)
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },


    doOnIdCardCheckSuccess(name, idCardNo) {
      console.log("doOnIdCardCheckSuccess param " + name + idCardNo)

      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }

      if (this.step === 0) {
        this.$message.warning("请点击开始身份证签离")
        return
      }

      this.visitor = {name: name, idCardNo: idCardNo}

      console.log("doOnIdCardCheckSuccess param " + idCardNo)
      visitorSearchByIdCardNo(idCardNo).then(({data}) => {
        console.log("visitorSearchByIdCardNo" + JSON.stringify(data))
        if (data.code === 200 && data.data.length > 0) {
          this.searchVisitorList = data.data
          if (this.searchVisitorList.length === 1) {
            this.doOnGetVisitor(this.searchVisitorList[0])
          } else {
            this.selectVisitorDialogVisible = true
          }
        } else {
          this.$message.error("未找到对应的访客信息")
          this.logE("VisitCodeCome visitorSearchByIdCardNo false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome visitorSearchByIdCardNo err", err)
        this.showNetErrMsg()
      })

    },

    doOnGetVisitor(visitor) {
      if (this.checkIsVisitorUsual(visitor)) {
        let areaId = this.$store.state.areaId
        let deviceId = this.$store.state.deviceId
        this.doUsualSignLeave(visitor, deviceId, areaId)
        return
      }
      this.selectVisitorDialogVisible = false
      this.selectVisitor = visitor

      this.step = 0

      getApplyListByVisitCode(visitor.code).then(({data}) => {
        console.log("getApplyListByVisitCode", data)
        this.applyList = []
        if (data.code === 200) {
          // 已签离的预约不再显示（completeState=LEAVE）
          let rawList = data.data || []
          let applyList = rawList.filter(item => item.completeState !== "LEAVE")
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: item.visitor.name,
                myEmployeeName: item.employee.name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;
           if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignLeave(this.applyList[0].data)
            }
          } else if (rawList.length > 0) {
            this.$message.warning("该访客均已签离，无需重复签离")
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showNetErrMsg(data.code)
          this.logE("VisitCodeCome getApplyListByVisitCode false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeCome getApplyListByVisitCode err", err)
        this.showNetErrMsg()
      })
    },

    doOnIdCardCheckFalse() {
      this.notify = {
        title: "身份证核验失败",
        show: true,
        success: false,
        msg: "身份证核验失败"
      }
    },

    onNotifyDialogClose() {
      this.notify.show = false
      if (this.visitor === null) {
        this.$router.back()
        this.$router.back()
      }
    },


    onCancelClick() {
      this.$router.back()
    },


    doSignLeave(applyInfo) {
      let applyId = applyInfo.id
      let visitorCode = this.selectVisitor.code
      let deviceId = this.$store.state.deviceId
      let areaId = this.$store.state.areaId
      signLeave(applyId, visitorCode, deviceId, areaId).then(({data}) => {
        console.log("signLeave", data)
        if (data.code === 200) {
          if (data.data.exist === "EXIST") {
            this.notify = {title: "签离结果", show: true, false: true, msg: "您已签离，无需再次签离",}
          } else {
            this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
          }
        } else if (data.code === 720) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "未同意签离或者签离超时",
          }
        } else if (data.code === 201) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败，没有找到签到记录",
          }
        } else {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败",
          }
        }
      }).catch((err) => {
        this.notify = {
          title: "签离结果",
          show: true,
          success: false,
          msg: "签离失败，网络异常",
        }
        this.logE("VisitCodeLeave signLeave err", err)
      })
    },


    checkIdCard() {
      if (this.notify.show || this.selectVisitorDialogVisible || this.showApplyList) {
        console.log("checkIdCard dialog is showing return")
        return
      }
      try {
        let readResult = this.JavaCardApi.readCard()
        console.log("@@@ checkIdCard" + readResult)
        if (readResult) {
          let result = JSON.parse(readResult)
          if (result.isSuccess) {
            const name = result.name
            const idCardNo = result.idCard
            this.doOnIdCardCheckSuccess(name, idCardNo)
          }
        }
      } catch (err) {
        console.log("checkIdCard")
      }

    },

    onEnsureClick() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }
      this.step = 1

      // this.IdCardCheck.startCheckIdCard()

    },
  }, // end methods
  filters: {
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    }
  }
}
</script>

<style scoped lang="less">


.dialog-container {
  display: flex;
  flex-direction: column; /* 设置为纵向布局 */
  justify-content: center;
  max-height: 500px;
  overflow-y: auto; /* 设置纵向滚动条自动显示 */
}

.dialog-sign {
  display: flex;
  height: 50vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.dialog-main {
  .dialog-content {
    height: 50vh;
    overflow: auto;
  }

  .dialog-footer {
    padding: 0;
  }
}

.show-qr-notify {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .el-image {
    //width:  400px;
  }

  .notify-big {
    margin-top: 60px;
    font-size: 3rem;
    color: #606266;

  }
}
</style>
